export default __webpack_public_path__ + "static/stats_2_ru-e3300a0284b97685155d0a530a13cb9d.png";